import {
    IBulkContextTranslations,
    IBulkPushTranslations,
    TranslateModel,
} from "./interfaces";
import types from "./types";

import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";

export const translateCreate = (
    project: string,
    data: TranslateModel,
    onResponse?: Function,
) =>
    request(
        types.STORE_REQUEST,
        types.STORE_FAILED,
        types.STORE_SUCCESS,
        "translateCreate",
        {
            data,
            url: { project },
        },
        onResponse,
    );

export const translateGoogle = (
    project: string,
    data: TranslateModel,
    onResponse?: Function,
) =>
    request(
        types.TRANSLATE_GOOGLE_REQUEST,
        types.TRANSLATE_GOOGLE_FAILED,
        types.TRANSLATE_GOOGLE_SUCCESS,
        "translateGoogle",
        {
            data,
            url: { project },
        },
        onResponse,
    );

export const translateToService = (
    project: string,
    data?: TranslateModel,
    onResponse?: Function,
) =>
    request(
        types.TRANSLATE_TO_SERVICE_REQUEST,
        types.TRANSLATE_TO_SERVICE_FAILED,
        types.TRANSLATE_TO_SERVICE_SUCCESS,
        "translateToService",
        {
            data,
            url: { project },
        },
        onResponse,
    );

export const translateDelete = (
    id: number,
    project: string,
    onResponse?: Function,
) =>
    request(
        types.DESTROY_REQUEST,
        types.DESTROY_FAILED,
        types.DESTROY_SUCCESS,
        "translateDelete",
        {
            url: { id, project },
        },
        onResponse,
    );

export const translateFetch = (project: string, config?: AxiosRequestConfig) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "translateFetch",
        {
            config,
            url: {
                project,
            },
        },
    );

export const translateGet = (
    id: number,
    project: string,
    config?: AxiosRequestConfig,
    onResponse?: Function,
) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "translateGet",
        {
            config,
            url: {
                project,
                id,
            },
        },
        onResponse,
    );

export const translateTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});

export const translateUpdate = (
    id: number,
    project: string,
    data: any,
    onResponse?: Function,
) => {
    return request(
        types.UPDATE_REQUEST,
        types.UPDATE_FAILED,
        types.UPDATE_SUCCESS,
        "translateUpdate",
        {
            data,
            url: { id, project },
        },
        onResponse,
    );
};

export const translatePatch = (
    id: number,
    project: string,
    data: any,
    onResponse?: Function,
) => {
    return request(
        types.PATCH_REQUEST,
        types.PATCH_FAILED,
        types.PATCH_SUCCESS,
        "translatePatch",
        {
            data,
            url: { id, project },
        },
        onResponse,
    );
};

export const translateCompareTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_COMPARE_UPDATE,
    action,
    data,
});

export const translateCompareFetch = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_COMPARE_REQUEST,
        types.FETCH_COMPARE_FAILED,
        types.FETCH_COMPARE_SUCCESS,
        "translateCompareFetch",
        {
            config,
        },
    );

export const translateBulkPush = (
    data: IBulkPushTranslations,
    onResponse?: Function,
) =>
    request(
        types.BULK_ADD_REQUEST,
        types.BULK_ADD_FAILED,
        types.BULK_ADD_SUCCESS,
        "translateBulkPush",
        {
            data,
        },
        onResponse,
    );

export const translate = (
    id: number,
    project: string,
    target_langs: string[],
    config?: AxiosRequestConfig,
    onResponse?: Function,
) =>
    request(
        types.TRANSLATE_REQUEST,
        types.TRANSLATE_FAILED,
        types.TRANSLATE_SUCCESS,
        "translate",
        {
            config: {
                ...config,
                params: {
                    ...config?.params,
                    target_langs,
                },
            },
            url: { id, project },
        },
        onResponse,
    );

export const translateBulk = (
    ids: number[],
    project: string,
    target_langs: string[],
    config?: AxiosRequestConfig,
    onResponse?: Function,
) =>
    request(
        types.TRANSLATE_BULK_REQUEST,
        types.TRANSLATE_BULK_FAILED,
        types.TRANSLATE_BULK_SUCCESS,
        "translateBulk",
        {
            data: {
                ids,
                target_langs,
            },
            config,
            url: { project },
        },
        onResponse,
    );

export const translateBulkImport = (
    project: string,
    data: Record<string, string>,
    onResponse?: Function,
) =>
    request(
        types.BULK_IMPORT_REQUEST,
        types.BULK_IMPORT_FAILED,
        types.BULK_IMPORT_SUCCESS,
        "translateBulkImport",
        {
            data,
            url: { project },
        },
        onResponse,
    );

export const translateContextBulk = (
    project: string,
    data: IBulkContextTranslations,
    onResponse?: Function,
) =>
    request(
        types.CONTEXT_BULK_REQUEST,
        types.CONTEXT_BULK_FAILED,
        types.CONTEXT_BULK_SUCCESS,
        "translateContextBulk",
        {
            data,
            url: { project },
        },
        onResponse,
    );

export const translateImprove = (
    sourceLang: string,
    text: string,
    config?: AxiosRequestConfig,
    onResponse?: Function,
) =>
    request(
        types.IMPROVE_TEXT_REQUEST,
        types.IMPROVE_TEXT_FAILED,
        types.IMPROVE_TEXT_SUCCESS,
        "translateImprove",
        {
            config: {
                ...config,
                params: {
                    source_lang: sourceLang,
                    text,
                },
            },
        },
        onResponse,
    );
